/**
 * 卡片页
 */
import React from 'react';
import PropTypes from 'prop-types';

class Main extends React.Component {

    componentDidMount() {
        this.props.history.replace({
            pathname: '/home/operation/company'
        });
    }

    render() {
        return (
            <div></div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object, // 路由
};

export default Main;